import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreIncidents } from '../../../Types/StoreTypes';

const initialState: StoreIncidents = {
    incidents: [],
    hasIncidents: false,
};

const openAIIncidentsSlice = createSlice({
    name: 'openAIIncidents',
    initialState,
    reducers: {
        setIncidents: (state, action: PayloadAction<StoreIncidents['incidents']>) => {
            state.incidents = action.payload;
            state.hasIncidents = action.payload.length > 0;
        },
    },
});

export const { setIncidents } = openAIIncidentsSlice.actions;

export default openAIIncidentsSlice.reducer;
